import { FC, invalidateQuery } from '../../../Services'
import { showToast } from '../../../utils/toast'

export const handleContinueClick = async (conversation) => {
  const { id: processId } = conversation.processes?.find((process) => process.state === 5) || {}
  try {
    const processSteps = await FC.service('processStep').find({ query: { processId } })
    const firstErrorStep = processSteps.find((item) => item.stepState === 5)
    if (firstErrorStep) {
      const firstErrorStepIndex = processSteps.findIndex((item) => item.stepState === 5)
      await FC.service('processStep').patch(firstErrorStep.id, { stepState: 2 })
      for (let i = firstErrorStepIndex + 1; i < processSteps.length; i++)
        await FC.service('processStep').remove(processSteps[i].id)
    }
    await FC.service('process').patch(processId, { state: 7 })
    await FC.service('conversations').patch(conversation.id, { status: 'open' })
    invalidateQuery('conversation')
    showToast('success', 'Successo', 'Operazione effettuata con successo')
  } catch (error) {
    showToast(
      'error',
      'Errore',
      error?.message || "Errore durante l'esecuzione dell'operazione"
    )
  }
}
